import React, {useEffect, useState} from 'react';

function Home(props) {
    const [active, setActive] = useState(false);

    useEffect(() => {
        let result = props.state.filter(function(item) {
            return item.checked === true;
        });

        result.length === 0 ? setActive(true) : setActive(false)
    });


    const applyFilter = () => {
        const selectedType = [];
        let resultStatus = props.state.filter(function(item) {
            return item.checked === true && item.type === 'Status';
        });
        resultStatus.map((item) => {
            selectedType.push(item.id.toString())
        });
        props.selectedStatus(selectedType);
        props.close();
    };

    return (
        <div>
            {
                props.state.map((item, index) => {
                    return <li
                        key={index}
                        onClick={() => props.method(item.id)}
                        className='d-flex align-items-center mb-3 cursor-pointer'
                    >
                        <div className={item.checked ? 'checked position-relative' : 'unchecked'}/>
                        <span className={item.checked ? 'text-green ml-3' : 'text-white ml-3'}>{item.name}</span>
                    </li>
                })
            }
            <div className='d-flex justify-content-between'>
                <p className='text-white cursor-pointer font-weight-bold'  onClick={() => {props.selectedUser([]); props.selectedStatus([]); props.method('cancel'); props.close()}}>Clear</p>
                <p
                    onClick={() => applyFilter()}
                    className={active ? 'text-grey font-weight-bold' : 'text-green cursor-pointer font-weight-bold'}
                    style={active ? {pointerEvents: 'none'} : {}}
                >Apply</p>
            </div>
        </div>
    );
}

export default Home;